'use client'

import Image from 'next/image'
import Link from 'next/link'
import { appPath } from '@/lib/getPublicAppUrl'

const MERCY_LOGO_SRC = appPath('/tenants/mercy/mercy-logo.svg')

/** Intrinsic asset dimensions (required by next/image for aspect ratio / CLS). */
const MERCY_LOGO_INTRINSIC_WIDTH = 840
const MERCY_LOGO_INTRINSIC_HEIGHT = 333
const MERCY_LOGO_HEIGHT_BY_SIZE = {
    header: 32,
    footer: 91,
} as const

type MercyLogoSize = keyof typeof MERCY_LOGO_HEIGHT_BY_SIZE

/** Mercy wordmark linked to the tenant home route. */
export function MercyLogo({ size = 'header' }: { size?: MercyLogoSize }) {
    const displayHeight = MERCY_LOGO_HEIGHT_BY_SIZE[size]
    const displayWidth = Math.round((MERCY_LOGO_INTRINSIC_WIDTH / MERCY_LOGO_INTRINSIC_HEIGHT) * displayHeight)

    return (
        <Link
            href="/"
            data-dd-privacy="allow"
            style={{ textDecoration: 'none', cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
            data-testid="mercy-logo-link"
        >
            <Image
                src={MERCY_LOGO_SRC}
                alt="Mercy"
                width={MERCY_LOGO_INTRINSIC_WIDTH}
                height={MERCY_LOGO_INTRINSIC_HEIGHT}
                sizes={`${displayWidth}px`}
                quality={100}
                style={{ height: displayHeight, width: 'auto' }}
                data-dd-privacy="allow"
                data-testid="mercy-logo"
            />
        </Link>
    )
}
